<div class="border"></div>
<div style="height: 10vh"></div>
<div class="container">
    <div class="card">
        <img alt="isoFarm" src="./assets/images/default/logo-isofarm.svg" />
        <h1 class="card__text-center">{{ 'privacy-policy.title' | translate }}</h1>
        <div class="card__text-right">
            <em>{{ 'privacy-policy.last-update' | translate }}</em>
            <hr>
        </div>
        <div class="row col-md-12">
            <p>{{ 'privacy-policy.intro' | translate }}</p>

            <p><em>{{ 'privacy-policy.read-carefully' | translate }}</em></p>

            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.ownership-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.ownership-content' | translate }}</p>

            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.collect-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.collect-intro' | translate }}</p>

            <ul>
                <li>{{ 'privacy-policy.collect-item-name' | translate }}</li>
                <li>{{ 'privacy-policy.collect-item-email' | translate }}</li>
                <li>{{ 'privacy-policy.collect-item-contact' | translate }}</li>
                <li>{{ 'privacy-policy.collect-item-device' | translate }}</li>
                <li>{{ 'privacy-policy.collect-item-location' | translate }}</li>
                <li>{{ 'privacy-policy.collect-item-agri' | translate }}</li>
            </ul>

            <p>{{ 'privacy-policy.collect-payment' | translate }}</p>

            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.use-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.use-intro' | translate }}</p>

            <ul>
                <li>{{ 'privacy-policy.use-item-deliver' | translate }}</li>
                <li>{{ 'privacy-policy.use-item-communicate' | translate }}</li>
                <li>{{ 'privacy-policy.use-item-other' | translate }}</li>
            </ul>

            <p>{{ 'privacy-policy.no-share-intro' | translate }}</p>

            <ul>
                <li>{{ 'privacy-policy.no-share-public' | translate }}</li>
                <li>{{ 'privacy-policy.no-share-third' | translate }}</li>
            </ul>

            <p>{{ 'privacy-policy.service-providers' | translate }}</p>

            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.not-directly-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.not-directly-candidate' | translate }}</p>
            <p>{{ 'privacy-policy.not-directly-research' | translate }}</p>
            <p>{{ 'privacy-policy.not-directly-no-sell' | translate }}</p>

            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.aggregated-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.aggregated-definition' | translate }}</p>
            <p>{{ 'privacy-policy.aggregated-uses-intro' | translate }}</p>

            <ul>
                <li>{{ 'privacy-policy.aggregated-item-deliver' | translate }}</li>
                <li>{{ 'privacy-policy.aggregated-item-marketing' | translate }}</li>
                <li>{{ 'privacy-policy.aggregated-item-other' | translate }}</li>
            </ul>

            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.other-uses-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.other-uses-intro' | translate }}</p>

            <ul>
                <li>{{ 'privacy-policy.other-uses-item-comply' | translate }}</li>
                <li>{{ 'privacy-policy.other-uses-item-protect' | translate }}</li>
            </ul>

            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.marketing-title' | translate }}</strong></p>
            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.marketing-use-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.marketing-use-content' | translate }}</p>
            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.opt-out-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.opt-out-content' | translate }}</p>
            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.delete-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.delete-content' | translate }}</p>
            <p>{{ 'privacy-policy.delete-limitations-intro' | translate }}</p>

            <ul>
                <li>{{ 'privacy-policy.delete-item-aggregated' | translate }}</li>
                <li>{{ 'privacy-policy.delete-item-active' | translate }}</li>
            </ul>

            <p>{{ 'privacy-policy.delete-legal' | translate }}</p>
            <p [innerHTML]="'privacy-policy.delete-contact' | translate"></p>

            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.share-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.share-p1' | translate }}</p>
            <p>{{ 'privacy-policy.share-p2' | translate }}</p>

            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.security-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.security-p1' | translate }}</p>
            <p>{{ 'privacy-policy.security-p2' | translate }}</p>
            <p>{{ 'privacy-policy.security-p3' | translate }}</p>
            <p>{{ 'privacy-policy.security-p4' | translate }}</p>

            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.independent-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.independent-content' | translate }}</p>

            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.minors-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.minors-content' | translate }}</p>

            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.international-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.international-content' | translate }}</p>
            <p>&nbsp;</p>

            <p><strong>{{ 'privacy-policy.online-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.online-intro' | translate }}</p>

            <ul>
                <li [innerHTML]="'privacy-policy.online-item-browser' | translate"></li>
                <li [innerHTML]="'privacy-policy.online-item-cookies' | translate"></li>
                <li [innerHTML]="'privacy-policy.online-item-pixel' | translate"></li>
                <li [innerHTML]="'privacy-policy.online-item-ip' | translate"></li>
                <li [innerHTML]="'privacy-policy.online-item-location' | translate"></li>
            </ul>

            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.third-party-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.third-party-intro' | translate }}</p>

            <ul>
                <li>{{ 'privacy-policy.third-party-item-sites' | translate }}</li>
                <li>{{ 'privacy-policy.third-party-item-apps' | translate }}</li>
            </ul>

            <p>{{ 'privacy-policy.third-party-ugc' | translate }}</p>
            <p>&nbsp;</p>

            <p><strong>{{ 'privacy-policy.updates-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.updates-content' | translate }}</p>

            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.contact-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.contact-content' | translate }}</p>

            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.lgpd-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.lgpd-intro' | translate }}</p>
            <ul>
                <li [innerHTML]="'privacy-policy.lgpd-item-confirmation' | translate"></li>
                <li [innerHTML]="'privacy-policy.lgpd-item-correction' | translate"></li>
                <li [innerHTML]="'privacy-policy.lgpd-item-anonymization' | translate"></li>
                <li [innerHTML]="'privacy-policy.lgpd-item-portability' | translate"></li>
                <li [innerHTML]="'privacy-policy.lgpd-item-erasure' | translate"></li>
                <li [innerHTML]="'privacy-policy.lgpd-item-sharing' | translate"></li>
                <li [innerHTML]="'privacy-policy.lgpd-item-no-consent' | translate"></li>
                <li [innerHTML]="'privacy-policy.lgpd-item-revocation' | translate"></li>
                <li [innerHTML]="'privacy-policy.lgpd-item-opposition' | translate"></li>
                <li [innerHTML]="'privacy-policy.lgpd-item-anpd' | translate"></li>
            </ul>
            <p [innerHTML]="'privacy-policy.lgpd-response-time' | translate"></p>

            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.cookies-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.cookies-p1' | translate }}</p>
            <p [innerHTML]="'privacy-policy.cookies-p2' | translate"></p>

            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.retention-title' | translate }}</strong></p>
            <ul>
                <li [innerHTML]="'privacy-policy.retention-item-logs' | translate"></li>
                <li [innerHTML]="'privacy-policy.retention-item-account' | translate"></li>
                <li>{{ 'privacy-policy.retention-item-agri' | translate }}</li>
            </ul>

            <p>&nbsp;</p>
            <p><strong>{{ 'privacy-policy.dpo-title' | translate }}</strong></p>
            <p>{{ 'privacy-policy.dpo-content' | translate }}</p>
            <p [innerHTML]="'privacy-policy.dpo-email' | translate"></p>

            <a (click)="voltar()" class="button button__primary">{{ 'privacy-policy.back' | translate }}</a>
        </div>
    </div>
</div>
